import { ErrorDto, ParsedErrorDto } from "../models/dtos/error.dto";

export class Errors {
  public static readonly errorGenericTitle: string = "TÜH!";
  public static readonly errorGenericText: string =
    "Bir sorun oluştu. Tekrar dene kazanmaya devam et!";

  public static readonly errorMessageInvalidOtp: string = "otp_failed";
  public static readonly errorMessageSaveFailed: string = "save-failed";

  /**
   * Update isHandledWithPaymentErrorModal method
   */
  public static readonly errorChargeFailed: string = "charge-failed";
  public static readonly errorHasSavedCard: string = "has-saved-card";
  public static readonly errorSendOtpAttemptFailed: string =
    "sendOtp-attempt-failed";
  public static readonly errorMobilePaymentNotFound: string =
    "mobile-payment-not-found";
  public static readonly errorMobilePaymentLimit: string =
    "mobile-payment-limit";
  public static readonly errorMobilePaymentEulaExpired: string =
    "mobile-payment-eula-expired";
  public static readonly errorGeneralOtpFailed: string =
    "provisionAll-attempt-failed";
  public static readonly errorBalanceFailed: string =
    "provisionAll-attempt-insufficient-limit";

  public static readonly ErrorGeneric: ErrorDto = {
    status: 500,
    path: "",
    message: "Something went wrong",
  };

  public static readonly ErrorInvalidToken: ErrorDto = {
    status: 401,
    path: "",
    message: "Invalid token",
  };

  public static getErrorDtoFromApiError = (error: any): ErrorDto => {
    if (!error.response || !error.response.data) {
      return this.ErrorGeneric;
    }
    return error.response.data;
  };

  private static getParsedErrorDtoFromApiError = (
    error: any
  ): ParsedErrorDto => {
    return JSON.parse(JSON.stringify(error)) as ParsedErrorDto;
  };

  public static isAuthError(error: any) {
    if (this.isApiEventError(error)) {
      return false;
    }
    // Empty response for auth error, get status manually.
    const status = this.getParsedErrorDtoFromApiError(error).status;
    return status === 401 || status === 403;
  }

  public static isApiEventError(error: any): boolean {
    const errorDto = this.getParsedErrorDtoFromApiError(error);
    return errorDto.config.url.includes(
      `${process.env.REACT_APP_BASE_URL_API_EVENT}`
    );
  }

  public static isOtpInvalidError(error: ErrorDto): boolean {
    return error.message === this.errorMessageInvalidOtp;
  }

  public static isOtpGeneralError(error: ErrorDto): boolean {
    return error.message === this.errorGeneralOtpFailed;
  }

  public static isOtpBalanceError(error: ErrorDto): boolean {
    return error.message === this.errorBalanceFailed;
  }

  public static isSaveFailedError(error: ErrorDto): boolean {
    return error.message === this.errorMessageSaveFailed;
  }

  public static isEtkError(error: ErrorDto) {
    return error.path === "/users/me/etk";
  }

  public static isPickedAnswerError(error: ErrorDto) {
    return error.path === "/answers/picked";
  }

  public static isHandledWithPaymentErrorModal(error: ErrorDto) {
    return [
      this.errorChargeFailed,
      this.errorHasSavedCard,
      this.errorSendOtpAttemptFailed,
      this.errorMobilePaymentNotFound,
      this.errorMobilePaymentLimit,
      this.errorMobilePaymentEulaExpired,
    ].includes(error.message);
  }
}
